module.exports = __webpack_public_path__ + "img/aljabi.c586c4b5.png";